import restful from '../vuex'

const state = {
  ...restful.states('sms_note')
}

const getters = {
  ...restful.getters('sms_note')
}

const actions = {
  ...restful.actions('sms_notes')
}

const mutations = {
  ...restful.mutations('sms_note')
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
